export default "<input type=\"file\" (change)=\"SelectFile($event)\" accept=\"{{ accept }}\" />";